<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Users</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
    <mat-label>User Type</mat-label>
    <mat-select [(ngModel)]="filter_options.userType" matTooltip="Filter users by type." name="userType">
      <mat-option value="">All</mat-option>
      <mat-option value="regular">Regular</mat-option>
      <mat-option value="support">Support (Super Admin)</mat-option>
    </mat-select>
    <mat-hint>Filter by regular or support (super admin) users.</mat-hint>
  </mat-form-field>

  <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Verification Status</mat-label>
    <mat-select [(ngModel)]="filter_options.verificationStatus" matTooltip="Filter users by email verification status." name="verificationStatus">
      <mat-option *ngFor="let option of verificationOptions" [value]="option.value">{{ option.label }}</mat-option>
    </mat-select>
    <mat-hint>Filters by the underlying status. Users shown as Verification required appear under Expired and Re-verification pending. Support users show as Exempt but are still matched by their underlying status, so set User Type to Regular to leave them out.</mat-hint>
  </mat-form-field>

  <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Blocked</mat-label>
    <mat-select [(ngModel)]="filter_options.blocked" matTooltip="Filter users by whether a super admin has blocked them." name="blocked">
      <mat-option value="">All</mat-option>
      <mat-option value="1">Blocked only</mat-option>
      <mat-option value="0">Not blocked</mat-option>
    </mat-select>
    <mat-hint>Users blocked by a super admin from this list. Separate from the verification sign-in block.</mat-hint>
  </mat-form-field>
  <div class="full-width mb-3">
    <button mat-stroked-button type="button" class="full-width" (click)="onSelectAssociatedAccounts()">
      <mat-icon>link</mat-icon>
      Associated Accounts<span *ngIf="filter_options.associatedAccounts.length"> ({{ filter_options.associatedAccounts.length }})</span>
    </button>
    <mat-hint>Accounts the user is actively linked to.</mat-hint>
  </div>

  <div class="full-width">
    <button mat-stroked-button type="button" class="full-width" (click)="onSelectEmployerAccounts()">
      <mat-icon>business</mat-icon>
      Employer Accounts<span *ngIf="filter_options.employerAccounts.length"> ({{ filter_options.employerAccounts.length }})</span>
    </button>
    <mat-hint>The user's employer (default) account.</mat-hint>
  </div>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-center my-2 py-2">
  <div class="p-2">
    <button type="button" mat-raised-button color="primary" (click)="onSaveAndClose()">
      <mat-icon>filter_list</mat-icon> Apply Filter
    </button>
  </div>
  <div class="p-2">
    <button type="button" mat-raised-button color="secondary" (click)="onClearAndClose()">
      <mat-icon>clear_all</mat-icon> Clear Filter
    </button>
  </div>
</mat-dialog-actions>
